import { lazy } from "react";
import Loadable from "../../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../../../../constants/enums";
import { COMM_AUTOMOBILE_BASIC_DETAILS } from "../Commerical.constants";
import { CommAutoGaragePlatesList } from "../CommAutoGaragePlate/CommAutoGaragePlateList";
import { CommAutoVehicleCoverageScheduleRoot } from "../VehicleCoverageScheduleRoot";
import { CommAutoScheduleAPage } from "../CommAutoSchedule/CommAutoScheduleA/CommAutoScheduleAPage";
import { CommAutomobileScheduleB } from "../CommAutoSchedule/CommAutoScheduleB/CommAutoScheduleB";
import { CommAutomobileScheduleD } from "../CommAutoSchedule/CommAutoScheduleD/CommAutoScheduleD";
import { CommAutomobileScheduleC } from "../CommAutoSchedule/CommAutoScheduleC/CommAutoScheduleC";
import { CommAutoApplicationRoot } from "../ApplicationRoot";
import { CommAutomobileCsioApplicationList } from "../CommAutoCSIOApplication/CommAutoCSIOApplicationList";
import { CommAutomobileCsioApplicationForm } from "../CommAutoCSIOApplication/commAutoCsioApplicationStepTab";
import { CommAutoMarketingRoot } from "../MarketingRoot";
import { CommAutoPolicyForms } from "../CommAutoPolicyForms/CommAutoPolicyForms";
import { CommAutoCSIOCertificate } from "../CommCSIOCertificate/CommCSIOCertificate";
import { CommAutoOPCF_28A } from "../CommAutoOPCF_28/CommAutoOPCF_28";
import { CommAutoTaskActivity } from "../TaskActivity/TaskActivity";
import { CommAutoCSIOEDocsList } from "../CommAutoCSIOEDOCS/CommAutoCsioEdocsList";
import { CommAutoCSIOEDocsWrapper } from "../CommAutoCSIOEDOCS/CommAutoCSIOEDocsWrapper";

const CommAutomobileBasicDetails = Loadable(
  lazy(() =>
    import("./CommAutoBasicDetails").then(({ CommAutomobileBasicDetails }) => ({
      default: CommAutomobileBasicDetails,
    }))
  )
);
const CommAutomobileApplicationForm = Loadable(
  lazy(() =>
    import("../CommAutoApplication/CommAutoApplication").then(
      ({ CommAutomobileApplicationForm }) => ({
        default: CommAutomobileApplicationForm,
      })
    )
  )
);
const CommAutoAlbertaApplicationForm = Loadable(
  lazy(() =>
    import("../CommAutoApplication/CommAutoAlbertaApplicationForm/CommAutoAlbertaApplicationStepsTab").then(
      ({ CommAutoAlbertaApplicationForm }) => ({
        default: CommAutoAlbertaApplicationForm,
      })
    )
  )
);
const CommAutomobileGarageApplicationOAF4 = Loadable(
  lazy(() =>
    import(
      "../CommAutoInsuranceGarageApplication/CommAutoInsuranceGarageApplication"
    ).then(({ CommAutomobileInsuranceGarageApplication }) => ({
      default: CommAutomobileInsuranceGarageApplication,
    }))
  )
);
const CommAutoSupplementaryFormTab = Loadable(
  lazy(() =>
    import("../CommAutoSupplementaryForm/CommAutoSupplementaryTab").then(
      ({ CommAutoSupplementaryForm }) => ({
        default: CommAutoSupplementaryForm,
      })
    )
  )
);
const CommAutomobileAddMarketing = Loadable(
  lazy(() =>
    import("../CommAutoMarketing/AddMarketing/CommAutoAddMarketing").then(
      ({ CommAutomobileAddMarketingHistory }) => ({
        default: CommAutomobileAddMarketingHistory,
      })
    )
  )
);
const CommAutomobileAuthorization = Loadable(
  lazy(() =>
    import("../CommAutoAuthorizationForm/CommAutoAuthorizationForm").then(
      ({ CommAutomobileAuthorization }) => ({
        default: CommAutomobileAuthorization,
      })
    )
  )
);
const CommAutomobileLiabilitySlips = Loadable(
  lazy(() =>
    import("../CommAutoLiabilitySlips/CommAutoLiabilitySlipsWrapper").then(
      ({ CommAutoLiabilitySlipsWrapper }) => ({
        default: CommAutoLiabilitySlipsWrapper,
      })
    )
  )
);
const CommAutomobileSharingFillable = Loadable(
  lazy(() =>
    import("../CommAutoSharingFillable/CommAutoSharingFillable").then(
      ({ CommAutoSharingFillable }) => ({
        default: CommAutoSharingFillable,
      })
    )
  )
);
const CommAutomobileRetireeDiscount = Loadable(
  lazy(() =>
    import("../CommAutoRetireeDiscount/CommAutoRetireeDiscount").then(
      ({ CommAutoRetireeDiscount }) => ({
        default: CommAutoRetireeDiscount,
      })
    )
  )
);
const CommAutomobileConsentForm = Loadable(
  lazy(() =>
    import("../CommAutoConsentForm/CommAutoConsentForm").then(
      ({ CommAutoConsentForm }) => ({
        default: CommAutoConsentForm,
      })
    )
  )
);
const CommAutomobileOPCF16 = Loadable(
  lazy(() =>
    import("../CommAutoOPCF_16/CommAutoOPCF_16").then(
      ({ CommAutoOPCF_16 }) => ({
        default: CommAutoOPCF_16,
      })
    )
  )
);
const CommAutomobileOPCF17 = Loadable(
  lazy(() =>
    import("../CommAutoOPCF_17/CommAutoOPCF_17").then(
      ({ CommAutoOPCF_17 }) => ({
        default: CommAutoOPCF_17,
      })
    )
  )
);
const CommAutomobileGarageForm = Loadable(
  lazy(() =>
    import("../CommAutoGarageForm/CommAutoGarageForm").then(
      ({ CommAutoGarageForm }) => ({
        default: CommAutoGarageForm,
      })
    )
  )
);
const CommAutomobileOwnerForm = Loadable(
  lazy(() =>
    import("../CommAutoOwnerForm/CommAutoOwnerForm").then(
      ({ CommAutoOwnerForm }) => ({
        default: CommAutoOwnerForm,
      })
    )
  )
);
const CommAutomobileDwellingDeclaration = Loadable(
  lazy(() =>
    import("../CommAutoDwellingDeclaration/CommAutoDwellingDeclaration").then(
      ({ CommAutoDwellingDeclaration }) => ({
        default: CommAutoDwellingDeclaration,
      })
    )
  )
);
const CommAutomobileDwelling = Loadable(
  lazy(() =>
    import("../CommAutoDwelling/CommAutoDwelling").then(
      ({ CommAutoDwelling }) => ({
        default: CommAutoDwelling,
      })
    )
  )
);
const CommAutoCancellation = Loadable(
  lazy(() =>
    import("../CommAutoCancellation/CommAutoCancellation").then(
      ({ CommAutoCancellation }) => ({
        default: CommAutoCancellation,
      })
    )
  )
);
const CommAutoHistory = Loadable(
  lazy(() =>
    import("../CommAutoBasicDetails/CommAutoHistory/CommAutoHistory").then(
      ({ CommAutoHistory }) => ({
        default: CommAutoHistory,
      })
    )
  )
);
// const CommAutomobileAttachmentList = Loadable(
//   lazy(() =>
//     import("../CommAutoBasicDetails/Attachment/AttachmentList").then(
//       ({ CommAutomobileAttachmentList }) => ({
//         default: CommAutomobileAttachmentList,
//       })
//     )
//   )
// );
const CommAutoAllTasks = Loadable(
  lazy(() =>
    import("../CommAutoPolicyNotes/CommAutoActivitiesTabs").then(({ CommAutoActivitiesTabs }) => ({
      default: CommAutoActivitiesTabs,
    }))
  )
);
const CommAutoInvoiceList = Loadable(
  lazy(() =>
    import("../CommAutoInvoiceList/CommAutoInvoiceTabs").then(
      ({ CommAutoInvoiceTabs }) => ({
        default: CommAutoInvoiceTabs,
      })
    )
  )
);
const CommAutoInvoiceHistoryWrapper = Loadable(
  lazy(() =>
    import("../CommAutoInvoiceList/CommAutoInvoiceHistoryWrapper").then(
      ({ CommAutoInvoiceHistoryWrapper }) => ({
        default: CommAutoInvoiceHistoryWrapper,
      })
    )
  )
);
const CommAutoInvoiceWrapper = Loadable(
  lazy(() =>
    import("../CommAutoInvoiceList/CommAutoInvoice").then(
      ({ CommAutoInvoiceWrapper }) => ({
        default: CommAutoInvoiceWrapper,
      })
    )
  )
);
const CommAutoBulkInvoiceWrapper = Loadable(
  lazy(() =>
    import("../CommAutoInvoiceList/CommAutoBulkInvoiceWrapper").then(
      ({ CommAutoBulkInvoiceWrapper }) => ({
        default: CommAutoBulkInvoiceWrapper,
      })
    )
  )
);
const CommAutoInvoicePaymentWrapper = Loadable(
  lazy(() =>
    import("../CommAutoInvoiceList/CommAutoInvoicePaymentWrapper").then(
      ({ CommAutoInvoicePaymentWrapper }) => ({
        default: CommAutoInvoicePaymentWrapper,
      })
    )
  )
);
const CommAutoPolicyChangeList = Loadable(
  lazy(() =>
    import("../CommAutoPolicyChange/CommAutoPolicyChangeList").then(
      ({ CommAutoPolicyChangeList }) => ({
        default: CommAutoPolicyChangeList,
      })
    )
  )
);
const CommAutoPolicyTelematics = Loadable(
  lazy(() =>
    import("../CommAutoPolicyTelematics/CommAutoPolicyTelematics").then(
      ({ CommAutoPolicyTelematics }) => ({
        default: CommAutoPolicyTelematics,
      })
    )
  )
);

const CommAutoPolicyContacts = Loadable(
  lazy(() =>
    import("../CommAutoPolicyContacts/CommAutoPolicyContacts").then(
      ({ CommAutoPolicyContacts }) => ({
        default: CommAutoPolicyContacts,
      })
    )
  )
);
const CommAutomobilePolicyChangeForm = Loadable(
  lazy(() =>
    import("../CommAutoPolicyChange/CommAutoPolicyChangeForm").then(
      ({ CommAutomobilePolicyChangeForm }) => ({
        default: CommAutomobilePolicyChangeForm,
      })
    )
  )
);

export const CommAutomobileRoutes = [
  {
    path: "/comm-automobile-policy/:customerId/basic-details/",
    exact: true,
    element: (
      <AuthorizedRoute
        moduleKeys={[
          MODULE_IDS.COMMERCIAL_AUTO,
          MODULE_IDS.COMM_AUTO_POLICY_ADMIN_MANAGER,
        ]}
      >
        <CommAutomobileBasicDetails />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${COMM_AUTOMOBILE_BASIC_DETAILS}/:customerPolicyId`,
    element: (
      <AuthorizedRoute
        moduleKeys={[
          MODULE_IDS.COMMERCIAL_AUTO,
          MODULE_IDS.COMM_AUTO_POLICY_ADMIN_MANAGER,
        ]}
      >
        <CommAutomobileBasicDetails />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/garage-plate-tab/:customerPolicyId",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoGaragePlatesList />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/vehicle-coverage-schedule-tab/:customerPolicyId",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoVehicleCoverageScheduleRoot />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/vehicle-coverage-schedule-tab/:customerPolicyId/scheduleA",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoScheduleAPage />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/vehicle-coverage-schedule-tab/:customerPolicyId/scheduleA/:incrementalNumber/:vehicleNumber",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoScheduleAPage />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/vehicle-coverage-schedule-tab/:customerPolicyId/scheduleB",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileScheduleB />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/vehicle-coverage-schedule-tab/:customerPolicyId/scheduleB/:driverNumber",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileScheduleB />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/vehicle-coverage-schedule-tab/:customerPolicyId/scheduleC",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileScheduleC />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/vehicle-coverage-schedule-tab/:customerPolicyId/scheduleC/:driverNumber",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileScheduleC />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/vehicle-coverage-schedule-tab/:customerPolicyId/scheduleD",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileScheduleD />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/vehicle-coverage-schedule-tab/:customerPolicyId/scheduleD/:driverNumber",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileScheduleD />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/application-tab/:customerPolicyId",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoApplicationRoot />
      </AuthorizedRoute>
    ),
  },
    {
    path: "/comm-automobile-policy/:customerId/application-tab/:customerPolicyId/alberta-application",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
       <CommAutoAlbertaApplicationForm/>
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/application-tab/:customerPolicyId/alberta-application/:incrementalNumber",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
      <CommAutoAlbertaApplicationForm/>
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/application-tab/:customerPolicyId/application",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileApplicationForm />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/application-tab/:customerPolicyId/application/:incrementalNumber",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileApplicationForm />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/application-csio-tab/:customerPolicyId",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileCsioApplicationList />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/application-csio-tab/:customerPolicyId/application/:messageGUID",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileCsioApplicationForm />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/marketing-tab/:customerPolicyId",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoMarketingRoot />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/marketing-tab/:customerPolicyId/marketing-history",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileAddMarketing />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/marketing-tab/:customerPolicyId/marketing-history/:marketingHistNumber",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileAddMarketing />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/policy-forms-tab/:customerPolicyId",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        {/* <CommAutoPolicyFormsRoot /> */}
        <CommAutoPolicyForms />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/authorization",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileAuthorization />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/authorization/:accountNumber",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileAuthorization />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/authorization/duplicate/:accountNumber",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileAuthorization isDuplicate />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/liability-slips/",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileLiabilitySlips />
      </AuthorizedRoute>
    ),
  },

  {
    path: "/comm-automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/liability-slips/:serialNumber",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileLiabilitySlips />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/liability-slips/duplicate/:serialNumber",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileLiabilitySlips isDuplicate />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/liability-insurance",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoCSIOCertificate />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/liability-insurance/:serialNumber",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoCSIOCertificate />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/liability-insurance/duplicate/:serialNumber",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoCSIOCertificate isDuplicate />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/sharing-fillable",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileSharingFillable />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/sharing-fillable/:serialNumber",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileSharingFillable />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/sharing-fillable/duplicate/:serialNumber",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileSharingFillable isDuplicate />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/retiree-discount",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileRetireeDiscount />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/retiree-discount/:serialNumber",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileRetireeDiscount />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/retiree-discount/duplicate/:serialNumber",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileRetireeDiscount isDuplicate />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/consent-form",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileConsentForm />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/consent-form/:serialNumber",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileConsentForm />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/consent-form/duplicate/:serialNumber",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileConsentForm isDuplicate />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/opcf-16",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileOPCF16 />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/opcf-16/:serialNumber",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileOPCF16 />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/opcf-16/duplicate/:serialNumber",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileOPCF16 isDuplicate />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/opcf-17",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileOPCF17 />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/opcf-17/:serialNumber",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileOPCF17 />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/opcf-17/duplicate/:serialNumber",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileOPCF17 isDuplicate />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/opcf-28A",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoOPCF_28A />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/opcf-28A/:serialNumber",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoOPCF_28A />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/opcf-28A/duplicate/:serialNumber",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoOPCF_28A isDuplicate />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/garage-form",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileGarageForm />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/garage-form/:serialNumber",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileGarageForm />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/owner-form",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileOwnerForm />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/owner-form/:serialNumber",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileOwnerForm />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/dwelling-declaration",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileDwellingDeclaration />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/dwelling-declaration/:serialNumber",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileDwellingDeclaration />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/dwelling-declaration-duplicate/:serialNumber",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileDwellingDeclaration isDuplicate />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/dwelling",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileDwelling />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/dwelling/:serialNumber",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileDwelling />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/dwelling-duplicate/:serialNumber",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileDwelling isDuplicate />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/cancellation/:taskCode",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoCancellation />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/policy-forms-tab/:customerPolicyId/cancellation/duplicate/:taskCode",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoCancellation isDuplicate />
      </AuthorizedRoute>
    ),
  },

  {
    path: "/comm-automobile-policy/:customerId/history-tab/:customerPolicyId",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoHistory />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/history-tab/:customerPolicyId/history/:taskNumber",
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoHistory />
      </AuthorizedRoute>
    ),
  },
  // {
  //   path: "/comm-automobile-policy/:customerId/attachments-tab/:customerPolicyId",
  //   element: (
  //     <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
  //       <CommAutomobileAttachmentList />
  //     </AuthorizedRoute>
  //   ),
  // },
  {
    path: "/comm-automobile-policy/:customerId/task-activity-tab/:customerPolicyId",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoTaskActivity />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/all-tasks/:customerPolicyId",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoAllTasks />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/invoices/:customerPolicyId",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoInvoiceList />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/invoices/:customerPolicyId/payment/history/:invoiceId",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
        <CommAutoInvoiceHistoryWrapper />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/invoices/:customerPolicyId/manage",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
        <CommAutoInvoiceWrapper />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/invoices/:customerPolicyId/manage/:invoiceId",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
        <CommAutoInvoiceWrapper />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/invoices/payments/:customerPolicyId/manage",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
        <CommAutoInvoicePaymentWrapper />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/invoices/:customerPolicyId/bulk-payment",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
        <CommAutoInvoicePaymentWrapper />
      </AuthorizedRoute>
    ),
  },
   {
    path: "/comm-automobile-policy/:customerId/invoices/:customerPolicyId/bulk-invoice",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_MARKETING]}>
        <CommAutoBulkInvoiceWrapper />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/policy-change-request-list/:customerPolicyId",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoPolicyChangeList />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/telematics/:customerPolicyId",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.AUTOMOBILE]}>
        <CommAutoPolicyTelematics />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/contacts/:customerPolicyId",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoPolicyContacts />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/policy-change-request/:customerPolicyId",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobilePolicyChangeForm />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/policy-change-request/:customerPolicyId/manage/:incrementalNumber",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobilePolicyChangeForm />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/application-tab/:customerPolicyId/garage-supplement",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoSupplementaryFormTab />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/application-tab/:customerPolicyId/garage-supplement/:serialNumber",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoSupplementaryFormTab />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/application-tab/:customerPolicyId/garage",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileGarageApplicationOAF4 />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/application-tab/:customerPolicyId/garage/:garageNumber",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileGarageApplicationOAF4 />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/csio-edocs-list/:customerPolicyId",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoCSIOEDocsList />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/csio-edocs-list/:customerPolicyId/manage-csio-edoc",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoCSIOEDocsWrapper />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/comm-automobile-policy/:customerId/csio-edocs-list/:customerPolicyId/manage-csio-edoc/:type/:csioEdocsId",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoCSIOEDocsWrapper />
      </AuthorizedRoute>
    ),
  },
];
